import type { TimeZone } from '@shared/utils/date';
import { useContext } from 'react';
import detailsContext from '@/view/fleet/pages/detailsContext';

export function useEquipmentTimeZone(id: string | undefined): {
  timeZone: TimeZone | undefined;
  isMixed: false;
};

export function useEquipmentTimeZone(ids: string[]): {
  timeZone: TimeZone | undefined;
  isMixed: boolean;
};

export function useEquipmentTimeZone(input: string | string[] | undefined): {
  timeZone: TimeZone | undefined;
  isMixed: boolean;
} {
  const { selectedEquipment } = useContext(detailsContext);
  const tzMap = new Map(
    selectedEquipment.map((e) => [e.id, e.timeZoneInfo?.effectiveTimeZone])
  );

  if (Array.isArray(input)) {
    const zones = input.map((id) => tzMap.get(id));
    const unique = new Set(zones);
    const isMixed = unique.size > 1;
    return {
      timeZone: isMixed
        ? undefined
        : (unique.values().next().value as string | undefined),
      isMixed,
    };
  }
  return {
    timeZone: input ? tzMap.get(input) : undefined,
    isMixed: false,
  };
}
